import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box, Container } from '@mui/material';
import { createAppTheme } from './theme';
import { cssVariables, resetRestaurantColors } from './theme/colors';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import RestaurantDetails from './pages/RestaurantDetails';
import MenuView from './pages/MenuView';
import ChatPage from './pages/ChatPage';
import './App.css';
import React from 'react';

// Create the default theme with pastel colors
const theme = createTheme(createAppTheme());

// Apply CSS variables to the document
const applyCSSVariables = () => {
  const root = document.documentElement;
  Object.entries(cssVariables).forEach(([property, value]) => {
    root.style.setProperty(property, value);
  });
};

function AppContent() {
  const location = useLocation();
  const isRestaurantDetails = location.pathname.startsWith('/restaurant/') && 
                             !location.pathname.includes('/menu') && 
                             !location.pathname.includes('/chat');

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {!isRestaurantDetails && <Header />}
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1, 
          ...(isRestaurantDetails ? { p: 0 } : { p: 0 })
        }}
      >
        {isRestaurantDetails ? (
          <Routes>
            <Route path="/restaurant/:id" element={<RestaurantDetails />} />
            <Route path="/restaurant/:id/menu" element={<MenuView />} />
            <Route path="/restaurant/:id/chat" element={<ChatPage />} />
          </Routes>
        ) : (
          <Container maxWidth={false} sx={{ px: { xs: 2, sm: 3, md: 4 }, py: 3 }}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
            </Routes>
          </Container>
        )}
      </Box>
    </Box>
  );
}

function App() {
  // Apply CSS variables when the app loads
  React.useEffect(() => {
    applyCSSVariables();
    
    // Reset restaurant colors when leaving restaurant pages
    const handleRouteChange = () => {
      if (!window.location.pathname.startsWith('/restaurant/')) {
        resetRestaurantColors();
      }
    };
    
    window.addEventListener('popstate', handleRouteChange);
    return () => window.removeEventListener('popstate', handleRouteChange);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
